export default __webpack_public_path__ + "crystallizer.png?cb22f03bf359d2e56a8af05beeb271dd";